import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../components/SubscriptionOptions2/SubscriptionOptions2.css';
import { notification } from "antd";

const SubscriptionOptions2 = ({ title, desc, pkg, price, extra, details, detail, buttonText, onConfirm, isSelected, onClick }) => (
  <div 
    className={`subscription-option ${isSelected ? 'selected' : ''}`} 
    onClick={onClick}
  >
    <h2>{title}</h2>
    <div className="desc">
      {desc.map((desc, index) => (
        <p key={index}>{desc}</p>
      ))}
    </div>
    <div className='plan'>
      <p className="pkg">{pkg}</p>
      <span className="price">{price}</span>
    </div>
    <span className="extra">{extra}</span>
    <ul className="details">
      {details.map((details, index) => (
        <li key={index}>{details}</li>
      ))}
    </ul>
    <button className={`confirm-button ${isSelected ? 'confirmed' : ''}`}>
      {isSelected ? 'Selected' : 'Confirm'}
    </button>    <div className="detail">
      {detail.map((detail, index) => (
        <p key={index}>{detail}</p>
      ))}
    </div>
  </div>
);

const SubscriptionOption2 = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const navigate = useNavigate();

  const handleConfirm = (option) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      navigate('/confirm-subs2', { state: { selectedOption } }); 
    } else {
      notification.warning({
        message: 'Warning',
        description: 'Please select a subscription option.',
        duration: 5,
      });      
    }
  };

  // Array of subscription options
  const options = [

    {
      title: "Pay Monthly",
      pkg: "£6.99",
      price: "/month ",
      extra: "+ 30p transaction charge",
      desc: ["Access to all our features for free for the first month, then:"],
      details: [],
      buttonText: "Confirm",
      detail: ["*Your subscription will automatically renew, but you can cancel at any time. You must give one month's notice before your subscription is cancelled. The monthly price is subject to change."]
    },
    {
      title: "Pay Annually",
      pkg: "£69.90",
      price: "/year ",
      extra: "",
      desc: ["Trial our basic features free of charge, without having to provide your payment details."],
      details: ["Get 12 months for the price of 10.", "No transaction fee."],
      buttonText: "Confirm",
      detail: ["*Cancel at any time, but you must have given one month's notice before your subscription is cancelled. The annual price is subject to change."]
    }
  ];

  return (
    <div className="subscription-options">
      <h1 className='heading'>Choose Your Subscription</h1>
      <p className='text'>Please select the payment option that best suits your needs. All options will take you directly to the secure payment provider platform. We have selected to use Stripe as our provider to ensure secure and efficient online protection of your data.</p>
      
      <div className="options-container">
        {options.map((option, index) => (
          <SubscriptionOptions2
            key={index}
            {...option}
            isSelected={selectedOption?.title === option.title} // Check if the option is selected
            onClick={() => handleConfirm(option)} // Set selected option
            onConfirm={() => handleConfirm(option)} // Set selected option on confirm
          />
        ))}
      </div>
      
      <button className="next-button" onClick={handleNext}>Next</button>
    </div>
  );
};

export default SubscriptionOption2;
